import React from "react";
import { TableCategories } from "../../components";

const Categories = () => {
  return (
    <div>
      <div className="m-2 md:m-10 p-2 md:p-6 bg-white rounded-3xl">
        <p className="text-xl mb-4 text-left"> Llojet e Kategorive</p>
        <TableCategories />
      </div>
    </div>
  );
};

export default Categories;
